import React, { PropsWithChildren, useId } from 'react';

const Row = ({ children }: PropsWithChildren) => {
    return (
        <div
            style={{
                display: 'flex',
                gap: '0.5rem',
            }}
        >
            {children}
        </div>
    );
};

interface HtmlElementBoxProps extends PropsWithChildren {
    name: string;
}
const HtmlElementBox = ({ name, children }: HtmlElementBoxProps) => {
    return (
        <div
            style={{
                border: '1px dashed #00b0ff',
                borderRadius: '0.25rem',
                padding: '1rem',
                flexGrow: 1,
            }}
        >
            <span>&lt;{name}&gt;</span>
            <div style={{ border: '1px dashed #eeeeee' }}>{children}</div>
        </div>
    );
};

interface IProps {
    isDisabled: boolean;
}

const ButtonsPage = ({ isDisabled }: IProps) => {
    const id = useId();

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
            <h2 style={{ margin: 0 }}>HTML Elements</h2>

            <Row>
                <HtmlElementBox name="div">
                    <div>Progress ThemeBuilder</div>
                </HtmlElementBox>

                <HtmlElementBox name="span">
                    <div>Progress ThemeBuilder</div>
                </HtmlElementBox>

                <HtmlElementBox name="p">
                    <p>Progress ThemeBuilder</p>
                </HtmlElementBox>

                <HtmlElementBox name="a">
                    <a
                        href="https://themebuilder.telerik.com/"
                        target="_blank"
                        rel="noreferrer"
                        aria-disabled={isDisabled}
                    >
                        Progress ThemeBuilder
                    </a>
                </HtmlElementBox>

                <HtmlElementBox name="li">
                    <li>Progress ThemeBuilder</li>
                </HtmlElementBox>

                <HtmlElementBox name="ul">
                    <ul>
                        <li>List Item</li>
                        <li>List Item</li>
                        <li>List Item</li>
                    </ul>
                </HtmlElementBox>

                <HtmlElementBox name="input">
                    <input disabled={isDisabled} value="Progress ThemeBuilder" onChange={() => {}} />
                </HtmlElementBox>
            </Row>

            <Row>
                <HtmlElementBox name="h1">
                    <h1>Progress ThemeBuilder</h1>
                </HtmlElementBox>

                <HtmlElementBox name="h2">
                    <h2>Progress ThemeBuilder</h2>
                </HtmlElementBox>

                <HtmlElementBox name="h3">
                    <h3>Progress ThemeBuilder</h3>
                </HtmlElementBox>

                <HtmlElementBox name="h4">
                    <h4>Progress ThemeBuilder</h4>
                </HtmlElementBox>

                <HtmlElementBox name="h5">
                    <h5>Progress ThemeBuilder</h5>
                </HtmlElementBox>

                <HtmlElementBox name="h6">
                    <h6>Progress ThemeBuilder</h6>
                </HtmlElementBox>
            </Row>

            <Row>
                <HtmlElementBox name="label">
                    <label htmlFor={id}>
                        Progress ThemeBuilder&nbsp;
                        <input id={id} />
                    </label>
                </HtmlElementBox>

                <HtmlElementBox name="strong">
                    <strong>Progress ThemeBuilder</strong>
                </HtmlElementBox>

                <HtmlElementBox name="b">
                    <b>Progress ThemeBuilder</b>
                </HtmlElementBox>

                <HtmlElementBox name="italic">
                    <i>Progress ThemeBuilder</i>
                </HtmlElementBox>
            </Row>
        </div>
    );
};

export default ButtonsPage;
